import { render, staticRenderFns } from "./FullSlideSvgWithNarrative.vue?vue&type=template&id=4b54d9dd&scoped=true&"
import script from "./FullSlideSvgWithNarrative.vue?vue&type=script&lang=js&"
export * from "./FullSlideSvgWithNarrative.vue?vue&type=script&lang=js&"
import style0 from "./FullSlideSvgWithNarrative.vue?vue&type=style&index=0&id=4b54d9dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b54d9dd",
  null
  
)

export default component.exports